import * as Sentry from '@sentry/react'
import { WithEnvironmentBanner } from '@/shell/components/EnvironmentBanner'
import { Shell } from '@/shell/components/Shell'
import { ThemeProvider } from '@/shell/components/ThemeProvider'

export default function App() {
  return (
    <ThemeProvider>
      <WithEnvironmentBanner>
        <Sentry.ErrorBoundary
          fallback={<div className="p-6">Something went wrong. Refresh and try again.</div>}
        >
          <Shell />
        </Sentry.ErrorBoundary>
      </WithEnvironmentBanner>
    </ThemeProvider>
  )
}
